const ALLOWED_IMAGE_TYPES = new Set(['image/jpeg', 'image/png', 'image/webp']);
const MAX_IMAGE_BYTES = 5 * 1024 * 1024;

export function validateCoinProductImage(file) {
  if (!file) {
    return 'Choose an image to upload.';
  }

  if (!ALLOWED_IMAGE_TYPES.has(file.type)) {
    return 'Image must be a JPG, PNG, or WebP file.';
  }

  if (file.size > MAX_IMAGE_BYTES) {
    return 'Image must be 5 MB or smaller.';
  }

  return null;
}
